import { FC } from 'react';
import { cx } from '@emotion/css';
import { Trans } from 'next-i18next';

import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { LinkOut } from '@phoenix/core/frontend/shared/ui/link-out/link-out';

type SharedHintLink = {
  name: string;
  url: string;
  isInline?: boolean;
  allowReferrer?: boolean;
};

interface SharedHintProps {
  hint: string;
  link?: SharedHintLink;
  className?: string;
  dataTestId?: string;
}

export const SharedHint: FC<SharedHintProps> = ({ className, hint, link, dataTestId }) => (
  <div
    className={cx(
      className,
      'flex flex-col gap-x-2 gap-y-4 rounded-lg border border-secondary-mid p-6 stihl-text-body-default-reg miniTablet:flex-row'
    )}
    data-testid={dataTestId}
  >
    <PhoenixIcon className="mt-1 h-4 max-w-[16px]" icon={getDesignSystemIcon('icon-info-16.svg')} />
    <div className="max-w-[600px]">
      <Trans
        i18nKey={hint}
        components={{
          ...(link && {
            [link.name]: (
              <LinkOut
                href={link.url}
                className={cx(!link.isInline && 'mt-1 block')}
                allowReferrer={link.allowReferrer}
                dataTestId={link.name}
              />
            ),
          }),
        }}
      />
    </div>
  </div>
);
